import { MediaRender } from '@components/MediaRender'
import { useCurrentLesson } from '@hooks/useCurrentLesson'
import { useImageStatus } from '@hooks/useImageStatus'
import { useMediaSize } from '@hooks/useMediaSize'
import { useEffect, useMemo } from 'react'

import {
  AnimatePresence,
  useWindowDimensions,
  View,
  XStack,
  YStack,
} from 'tamagui'
import { NotSupported } from '../../extra_contents/NotSupported'

export function ImageViewerPage() {
  const { currentLesson } = useCurrentLesson()
  const mediaSize = useMediaSize()
  const isMobile = ['xs', 'sm'].includes(mediaSize)
  const { isHighlightedImage, setIsHighlightedImage, reset } = useImageStatus()
  const media = currentLesson!.media

  const { width: windowWidth, height: windowHeight } = useWindowDimensions()

  const dynamicHeight = useMemo(() => {
    return isHighlightedImage ? windowHeight : windowHeight - 80
  }, [isHighlightedImage, windowHeight])

  useEffect(() => {
    reset()
  }, [reset])

  const handleToggleHighlight = () => {
    if (isMobile) {
      setIsHighlightedImage(!isHighlightedImage)
    }
  }

  return (
    <View w="100%" h="100%">
      <AnimatePresence>
        <View
          key="space-between-header-and-image"
          w="100%"
          h={isHighlightedImage ? 0 : 80}
          bg="$neutral-0"
          animation="quick"
          opacity={isHighlightedImage ? 0 : 1}
          flexShrink={0}
        />
        <YStack
          key="image-container"
          w="100%"
          h={dynamicHeight}
          f={1}
          maxHeight={dynamicHeight}
          bg="$neutral-100"
          alignItems="center"
          justifyContent="center"
          animation="quick"
          position="relative"
        >
          <XStack
            bg="transparent"
            position="absolute"
            w="100%"
            h="100%"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={10}
            onPress={handleToggleHighlight}
          />
          {media && (
            <View
              justifyContent="center"
              overflow="hidden"
              flex={1}
              maxWidth={windowWidth}
              maxHeight={windowHeight}
              alignItems="center"
            >
              <MediaRender media={media} isImageVariant isExpandedViewPage>
                <NotSupported media={media} />
              </MediaRender>
            </View>
          )}
        </YStack>
      </AnimatePresence>
    </View>
  )
}
